import Cookies from "js-cookie";
import localeCache from "../../helpers/LocaleCache"

export default {
    state: {
        cv_locale: Cookies.get("cv_locale"),
        cv_translate: {},
        name: localeCache.get('cv_name'),
        surname: localeCache.get('cv_surname'),
        photo: localeCache.get('cv_photo'),
        date: localeCache.get('cv_date'),
        career_objective: localeCache.get('cv_career_objective'),
        phone: localeCache.get('cv_phone'),
        email: localeCache.get('cv_email'),
        address: localeCache.get('cv_address', true),
        jobStack: localeCache.get('cv_job_stack', true),
        jobStackCurrency: localeCache.get('cv_job_stack_currency',true),
        jobStackPlus: false,
        cvTheme: localeCache.get('cv_theme', true),
        cvLanguages: localeCache.get('cv_languages', true),
        cvProfessions: localeCache.get('cv_professions', true),
        cvCitizens: localeCache.get('cv_citizens', true),
        cvSkills: localeCache.get('cv_skills', true),
        cvHobbies: localeCache.get('cv_hobbies', true),
        hasExperience: localeCache.getBool('hasExperience', true),
        tmpExperience: {
            start: localeCache.get('tmpExperienceStart'),
            end: localeCache.get('tmpExperienceEnd'),
            location: localeCache.get('tmpExperienceLocation', true),
            company: localeCache.get('tmpExperienceCompany'),
            specialization: localeCache.get('tmpExperienceSpecialization', true),
            description: localeCache.get('tmpExperienceDescription')
        },
        tmpExperienceEditIndex: null,
        experiences: localeCache.get('cv_experiences', true),
        tmpEducation: {
            start: localeCache.get('tmpEducationStart'),
            end: localeCache.get('tmpEducationEnd'),
            location: localeCache.get('tmpEducationLocation', true),
            university: localeCache.get('tmpEducationUniversity'),
            faculty: localeCache.get('tmpEducationFaculty'),
            degree: localeCache.get('tmpEducationDegree', true),
            specialization: localeCache.get('tmpEducationSpecialization', true),
            description: localeCache.get('tmpEducationDescription')
        },
        tmpEducationEditIndex: null,
        educations: localeCache.get('cv_educations', true),
        hasSocial: localeCache.getBool('hasSocial', true),
        tmpSocial: localeCache.get('tmpSocial', true),
        cvSocials: localeCache.get('cv_socials', true),
        cvSocialsEditIndex: null,
        hasHobby: localeCache.getBool('hasHobby', true),
        hasAchievement: localeCache.getBool('hasAchievement', true),
        hobby: localeCache.get('cv_hobby'),
        hobbies: localeCache.get('cv_hobbies', true),
        achievement: localeCache.get('achievement', true),
        downloadType: false,
            validation: [
     /*       {
                name: 'date',
                rules: 'required',
                blockId: 'basic-info',
            },
            {
                name: 'name',
                rules: 'required|min:3|max:255',
                blockId: 'basic-info',
            },
            {
                name: 'surname',
                rules: 'required|min:3|max:255',
                blockId: 'basic-info',
            },
            {
                name: 'career_objective',
                rules: 'required|min:3|max:255',
                blockId: 'basic-info',
            },
            {
                name: 'phone',
                rules: 'required',
                blockId: 'contacts',
            },*/
            {
                name: 'email',
                rules: 'required|email',
                blockId: 'contacts',
            },
       /*     {
                name: 'address|address',
                rules: 'required|min:3|max:255',
                blockId: 'contacts',
            },
            {
                name: 'jobStack|title',
                rules: 'required',
                blockId: 'job-stack'
            },
            {
                name: 'cvLanguages',
                rules: 'required',
                blockId: 'cv-languages'
            },
            {
                name: 'cvProfessions',
                rules: 'required',
                blockId: 'cv-professions'
            },
            {
                name: 'cvSkills',
                rules: 'required',
                blockId: 'cv-skills'
            },*/
            /*{
                name: 'educations',
                rules: 'required',
                blockId: 'cv-education'
            }*/
        ]
    },
    getters: {
        cv_t: state => key => {
            return state.cv_translate[key] || key
        },
        cv_locale: state => {
            return state.cv_locale
        },
        cv_name: state => {
            return state.name;
        },
        cv_surname: state => {
            return state.surname;
        },
        cv_email: state => {
            return state.email;
        },
        cv_phone: state => {
            return state.phone;
        },
        photo: state => {
            return state.photo;
        },
        achievement: state => {
            return state.achievement;
        },
        cv_date: state => {
            return state.cv_date;
        },
        career_objective: state => (text = null) => {
            return state.career_objective ? state.career_objective.replace(/(?:\r\n|\r|\n)/g, '<br />') : text
        },
        jobStack: state => {
            return state.jobStack;
        },
        jobStackCurrency: state => {
            return state.jobStackCurrency;
        },
        cvTheme: state => {
            return state.cvTheme;
        },
        cvLanguages: state => {
            return state.cvLanguages
        },
        cvProfessions: state => {
            var res = '';
            state.cvProfessions.forEach(profession => {
                res += `${profession.title} / `
            });

            return res.length ? res.slice(0, (res.length - 2)) : res
        },
        cvProfessionIds: state => {
            var ids = [];
            state.cvProfessions.forEach(profession => {
                ids.push(profession.id)
            });
            return ids
        },
        cvCitizens: state => {
            var res = '';
            if (state.cvCitizens) {
                state.cvCitizens.forEach(citizen => {
                    res += `${citizen.title} / `
                });
            }

            return res.length ? res.slice(0, (res.length - 2)) : res
        },
        cvCitizensIds: state => {
            var ids = [];
            if (state.cvCitizens) {
                state.cvCitizens.forEach(citizen => {
                    ids.push(citizen.id)
                });
            }
            return ids
        },
        cvSkillIds: state => {
            var ids = [];
            state.cvSkills.forEach(skill => {
                ids.push(skill.id)
            });
            return ids
        },
        cvHobbyIds: state => {
            var ids = [];
            state.cvHobbies.forEach(hobby => {
                ids.push(hobby.id)
            });
            return ids
        },
        languageIds: state => {
            var ids = [];
            state.cvLanguages.forEach(language => {
                ids.push(language.id)
            });
            return ids
        },
        downloadType: state => {
            return state.downloadType;
        },
        tmpEducationEditIndex: state => {
            return state.tmpEducationEditIndex;
        },
        tmpExperienceEditIndex: state => {
            return state.tmpExperienceEditIndex;
        },
        cvSocialsEditIndex: state => {
            return state.cvSocialsEditIndex;
        },
        hasHobby: state => {
            return state.hasHobby;
        }
    },
    mutations: {
        cv_name(state,data) {
          state.name = data;
        },
        cv_surname(state,data) {
            state.surname = data;
        },
        cv_email(state,data) {
            state.email = data;
        },
        cv_translation(state, data) {
            state.cv_translate = data
        },
        cv_locale(state, data) {
            state.cv_locale = data
        },
        jobStack(state, data) {
            state.jobStack = data;
        },
        jobStackCurrency(state, data) {
            state.jobStackCurrency = data;
        },
        cvTheme(state, data) {
            state.cvTheme = data;
        },
        cvLanguages(state, data) {
            state.cvLanguages = data
        },
        cvPhoto(state, data) {
            state.photo = data
        },
        cvProfessions(state, data) {
            state.cvProfessions = data
        },
        cvCitizens(state, data) {
            state.cvCitizens = data
        },
        cvSkills(state, data) {
            state.cvSkills = data
        },
        cvHobbies(state, data) {
            state.cvHobbies = data
        },
        cv(state, update) {
            state[update.key] = update.val;
        },
        downloadType(state, data) {
            state.downloadType = data;
        },
        cvPhone(state, data) {
            state.phone = data
        },
        tmpEducationEditIndex(state, data) {
            state.tmpEducationEditIndex = data
        },
        tmpExperienceEditIndex(state, data) {
            state.tmpExperienceEditIndex = data
        },
        cvSocialsEditIndex(state, data) {
            state.cvSocialsEditIndex = data
        },
    },
    actions:{
      async sendMailchimpApi({state}){
        return await axios.post(`/api/get/new-email`,{
          email_address: state.email,
          merge_fields:{
            FNAME:state.name,
            LNAME:state.surname,
            ADDRESS:state.address.address,
            PHONE:state.phone,
            BIRTHDAY:state.date
          }
        });
      },
    }
};



// WEBPACK FOOTER //
// ./resources/js/store/modules/cv.js